import serviceClient from './serviceClient';

let modules = null;

const getModules = async () => {
  try {
    if (!modules) {
      // const tenantClient = await serviceClient.getClient("tenant");
      // const result = await tenantClient.apis.tenant.getTenantLicense();
      // modules =
      //   result && result.obj && result.obj.modules ? result.obj.modules : null;

      // modules are in localStorage now
      const modulesString = localStorage.getItem("modules");
      modules = modulesString ? JSON.parse(modulesString) : null;
    }

    return modules;
  } catch (err) {
    console.error(err);
    console.error("Unable to get modules");
    return [];
  }
};

const checkModule = async function checkModule(id) {
  
    try {
  
      let moduleActive = false;
      await getModules();

      if (modules) {
          const matchingModule = modules.find(f => f.module_id === id);
          if (matchingModule) {
            moduleActive = true;
          }
      }
      return moduleActive;
  } catch (err) {
    console.error(err);
    console.error("Unable to get modules");
    return false;
  }
};
const getEditorModule = async () => {
  try {
    await getModules();

    if (modules) {
      let ids = [
        "DocumentEditorEnterprise",
        "DocumentEditorProfessional",
        "DocumentEditorStandard",
        "DocumentEditorBasic",
      ];
      return ids.find((id) => modules.some((m) => m.module_id === id));
    }
    return null;
  } catch (err) {
    console.error(err);
    console.error("Unable to get editor modules");
    return null;
  }
};

const getEditorModuleLevel = async () => {
  try {
    await getModules();

    if (modules) {
      const ids = {
        DocumentEditorEnterprise: 4,
        DocumentEditorProfessional: 3,
        DocumentEditorStandard: 2,
        DocumentEditorBasic: 1,
      };

      return Math.max(
        ...modules
          .filter((m) => m.module_id in ids)
          .map((m) => ids[m.module_id]),
        0
      );
    }

    return 0;
  } catch (err) {
    console.error(err);
    console.error("Unable to get editor module level");
    return 0;
  }
};

const hasIntelligentDocumentModule= async () => {
  return await checkModule("IntelligentDocumentProcessing");
};

export default {
  checkModule,
  getEditorModule,
  getEditorModuleLevel,
  hasIntelligentDocumentModule
};
